import React from "react";
import { 
    SubStepContainer,
    Step, 
    StepCircle, 
    StepLabel, 
    Arrow 
} from "./SubStepTracker.styles";

const SubStepTracker = ({ currentStep, customSteps = null }) => {
  const defaultSteps = [
    { id: 1, label: "Upload" },
    { id: 2, label: "Processed" },
    { id: 3, label: "Generate" },
  ];
  
  const steps = customSteps || defaultSteps;

  return (
    <SubStepContainer data-testid="substep-indicator">
      {steps.map((step, index) => {
        let status = "inactive";

        if (currentStep > step.id) {
          status = "completed"; 
        } else if (currentStep === step.id) {
          status = "active"; 
        }

        // Dynamic final step handling
        if (currentStep === steps.length && step.id === steps.length) {
          status = "active";
        }

        return (
          <React.Fragment key={step.id}>
            <Step active={status === "active"}>
              <StepCircle status={status}>{step.id}</StepCircle>
              <StepLabel>{step.label}</StepLabel>
            </Step>
            {index < steps.length - 1 && <Arrow>→</Arrow>}
          </React.Fragment>
        );
      })}
    </SubStepContainer>
  );
};

export default SubStepTracker;